import ContactAccordion from 'src/components/HelpInfo/ContactAccordion';
import AccordionList from 'src/components/HelpInfo/AccordionList';
import DownloadAccordion from 'src/components/HelpInfo/DownloadAccordion';

const AssetsHelpInfo = () => {
  return (
    <AccordionList
      accordions={[
        <ContactAccordion key="contactAccordion" />,
        <DownloadAccordion key="downloadAccordion" />,
      ]}
    />
  );
};

export default AssetsHelpInfo;
